import { render, staticRenderFns } from "./docShifting.vue?vue&type=template&id=10a84d18&scoped=true"
import script from "./docShifting.vue?vue&type=script&lang=js"
export * from "./docShifting.vue?vue&type=script&lang=js"
import style0 from "./docShifting.vue?vue&type=style&index=0&id=10a84d18&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a84d18",
  null
  
)

export default component.exports